/* AUXITO 政策页 —— FAQ 分栏联动（左侧选题，右侧切换答案）。
   无 JS 时 CSS 默认展开全部答案；JS 接管后只显示选中项。原生、无依赖。 */
(function () {
  var faqs = document.querySelectorAll('[data-auxito-faq]');
  if (!faqs.length) return;

  faqs.forEach(function (faq) {
    var questions = faq.querySelectorAll('[data-auxito-faq-q]');
    var answers = faq.querySelectorAll('[data-auxito-faq-a]');
    var questionList = Array.prototype.slice.call(questions);
    var answerList = Array.prototype.slice.call(answers);
    var tabList = faq.querySelector('.auxito-policy-faq__list');
    if (questionList.length < 2 || !answerList.length || !tabList) return;

    tabList.setAttribute('role', 'tablist');
    questionList.forEach(function (q) {
      q.setAttribute('role', 'tab');
    });
    answerList.forEach(function (a) {
      a.setAttribute('role', 'tabpanel');
    });
    faq.classList.add('is-enhanced');

    function activate(idx) {
      questionList.forEach(function (q) {
        var on = q.getAttribute('data-auxito-faq-q') === idx;
        q.classList.toggle('is-active', on);
        q.setAttribute('aria-expanded', on ? 'true' : 'false');
        q.setAttribute('aria-selected', on ? 'true' : 'false');
        q.setAttribute('tabindex', on ? '0' : '-1');
      });
      answerList.forEach(function (a) {
        var on = a.getAttribute('data-auxito-faq-a') === idx;
        a.classList.toggle('is-active', on);
        a.setAttribute('aria-hidden', on ? 'false' : 'true');
        a.hidden = !on;
      });
    }

    questionList.forEach(function (q, index) {
      q.addEventListener('click', function () {
        activate(q.getAttribute('data-auxito-faq-q'));
      });
      q.addEventListener('keydown', function (event) {
        var targetIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (index + 1) % questionList.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (index - 1 + questionList.length) % questionList.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = questionList.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        activate(questionList[targetIndex].getAttribute('data-auxito-faq-q'));
        questionList[targetIndex].focus();
      });
    });

    var current = faq.querySelector('.auxito-policy-faq__q.is-active');
    activate(current ? current.getAttribute('data-auxito-faq-q') : questionList[0].getAttribute('data-auxito-faq-q'));
  });
})();
